import axios from 'axios';
import {
  API_BASE,
  API_BASE_LOCAL,
  STARTING_POINT_DELEGATOR_URL,
  PDF_URL,
  SHOW_SEND_RESULTS_INFO_URL,
} from '../constants/constants';

const gateway = axios.create({
  baseURL: window.location.host.includes('localhost')
    ? API_BASE_LOCAL
    : API_BASE,
  headers: {
    'Cache-Control': 'no-store',
  },
});

export function getSchema(locId) {
  return gateway
    .get(`/sp/schema?locale=${locId}&sysId=PRP&appName=StartingPoint`)
    .then((res) => res.data);
}

export function getResults(query, locId) {
  return gateway
    .post(`/sp/results?locale=${locId}&sysId=PRP&appName=StartingPoint`, query)
    .then((res) => res.data);
}

export function getShowSendResults(
  faNo,
  conId,
  entityIdBase64,
  locId,
  conType,
  utmSource
) {
  return gateway({
    method: 'get',
    url: SHOW_SEND_RESULTS_INFO_URL,
    params: {
      sysId: 'PRP',
      appName: 'StartingPoint',
      conId,
      faNo,
      entityIdBase64,
      locale: locId,
      conType,
      utmSource,
    },
  }).then((res) => res.data);
}

export function getPDF({
  resultsToSendToDelegator,
  conId,
  contactName,
  locId,
  conType,
  userComments,
  utmSource,
  faNo,
  entityId,
}) {
  return gateway({
    method: 'post',
    url: PDF_URL,
    responseType: 'blob',
    params: {
      sysId: 'PRP',
      appName: 'StartingPoint',
      locale: locId,
      conType,
      utmSource,
    },
    data: {
      contactNo: conId,
      contactName,
      results: resultsToSendToDelegator,
      userComments,
      faNo,
      entityId,
    },
  }).then((res) => res.data);
}

export function sendToDelegator({
  data,
  locId,
  notifyFaInd,
  storeToDbInd,
  sendToUserInd,
  sendToSfInd,
  conType,
  utmSource,
  archiveInd,
}) {
  return gateway({
    method: 'post',
    url: STARTING_POINT_DELEGATOR_URL,
    params: {
      archiveInd,
      storeToDbInd,
      notifyFaInd,
      sendToUserInd,
      sendToSfInd,
      sysId: 'PRP',
      appName: 'StartingPoint',
      locale: locId,
      conType,
      utmSource,
    },
    data,
  }).then((res) => res.data);
}
